import React from "react";
import Modal from "react-bootstrap/Modal";
import ReactToPrint from "react-to-print";
import ReactDropdown from "react-dropdown";
class ComponentToPrint extends React.Component {
  render() {
    return (
      <div className="col-sm-12" style={{ width: "100%", color: "#000000" }}>
        <div
          style={{ padding: "15px" }}
          dangerouslySetInnerHTML={{ __html: this.props.data }}
        ></div>
      </div>
    );
  }
}

class ModalInHopDong extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      printContent: "",
      nhanvayId: 0,
      mauInId: 0,
      ListMauIn: [],
    };
  }

  componentDidMount() {
    let { getListMauInNhanVay } = this.props;
    getListMauInNhanVay();
  }
  componentDidUpdate() {
    let { getNoiDungInNhanVay, data, show } = this.props;
    let { mauInId, nhanvayId } = this.state;
    if (show && data && data.ID && data.ID !== nhanvayId) {
      this.setState({
        nhanvayId: data.ID,
      });
      getNoiDungInNhanVay({ mauhopdongId: mauInId, nhanvayId: data.ID });
    }
  }
  onChangeMauIn = () => (item) => {
    let { getNoiDungInNhanVay, data } = this.props;
    getNoiDungInNhanVay({ mauhopdongId: item.value, nhanvayId: data.ID });
  };
  render() {
    let props = this.props;
    let { inChoVayLoading, onHide, show, inNhanVay } = props;
    let { ListMauIn, NoiDungIn } = inNhanVay;
    let { mauInId } = this.state;
    setTimeout(() => {
      window
        .JsBarcode(".barcode")
        .options({
          width: 1,
          height: 26,
          margin: 0,
          fontSize: 15,
        })
        .init();
    }, 500);
    return (
      <Modal
        {...props}
        show={show}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-table-plus"></i>
            </span>
            In hợp đồng
          </h4>
          <button type="button" className="close-popup-new" onClick={onHide}>
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div
            className={
              "loader loader-default " + (inChoVayLoading ? "is-active" : "")
            }
          ></div>
          <div class="form tat-toan form-horizontal form-edit">
            <div class="form-body">
              <div class="card collapse-icon accordion-icon-rotate">
                <div
                  class="card-header border-info"
                  data-toggle="collapse"
                  href="#collapse19639"
                  aria-expanded="true"
                  aria-controls="collapse19639"
                >
                  <a class="card-title lead info collapsed" href={() => false}>
                    <h3>Thông tin hợp đồng</h3>
                  </a>
                </div>
                <div
                  id="collapse19639"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9639"
                  class="card-collapse collapse show"
                >
                  <div class="card-content">
                    <div class="card-body">
                      <div className="row">
                        <div class="col-sm-9"></div>
                        <div class="col-sm-3">
                          <br />
                          <ReactDropdown
                            onChange={this.onChangeMauIn()}
                            options={ListMauIn}
                            placeholder="Tất cả"
                            controlClassName="form-control input-sm ml-1 pad-col"
                            value={mauInId}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <ComponentToPrint
                          data={NoiDungIn}
                          ref={(el) => (this.componentRef = el)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size modal-footer text-right">
          <ReactToPrint
            trigger={() => {
              // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
              // to the root node of the returned component as it will be overwritten.
              return (
                <a class="btn btn-new-main btn-checknew" href={() => false}>
                  <span class="btn-icon-left">
                    <i class="mdi mdi-printer"></i>
                  </span>{" "}
                  In hợp đồng
                </a>
              );
            }}
            content={() => this.componentRef}
            copyStyles={false}
          />
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ModalInHopDong;
